'use client';
import { Body } from '@/components/DynamicText';
import React, { useEffect, useRef, useState } from 'react';

const TableofContent = ({ headings }: any) => {
  const [activeId, setActiveId] = useState('');
  const observer: any = useRef();

  useEffect(() => {
    const handleObsever = (entries: any) => {
      entries.forEach((entry: any) => {
        if (entry?.isIntersecting) {
          setActiveId(entry.target.id);
        }
      });
    };

    observer.current = new IntersectionObserver(handleObsever, {
      rootMargin: '-20% 0% -35% 0px',
    });

    const elements = document.querySelectorAll('h2');
    elements.forEach((elem) => observer.current.observe(elem));
    return () => observer.current?.disconnect();
  }, []);

  return (
    <section className=' sticky top-[175px] pr-[10px]'>
      <h3 className='mb-[20px] text-[20px] font-semibold dark:text-[white]'>
        In This Article
      </h3>
      <nav className='scroll-th scrollbar-white-shadow light:scrollbar-white-shadow-light dark:scrollbar-white-shadow-dark max-h-[250px] overflow-y-auto lg:max-h-[400px]'>
        {headings &&
          headings.map((item: string, index: number) => {
            let text = item.replace(/^#+\s*/, '').trim();
            text = text
              .replace(/\*\*(.*?)\*\*/g, '$1')
              .replace(/__(.*?)__/g, '$1');
            const headingid = text.replace(/\s+/g, '-').toLowerCase();
            return (
              <a key={`table:${index}`} className='' href={'#' + headingid}>
                <Body
                  className={`mb-[10px] text-[#596178] dark:text-[#9ea8ac] ${
                    activeId === headingid
                      ? `max-sm:text-[#00cfaf] lg:border-l-[2px] lg:border-[#00cfaf] lg:pl-[5px]`
                      : ``
                  }`}
                >
                  {text}
                </Body>
              </a>
            );
          })}
      </nav>
    </section>
  );
};

export default TableofContent;
